module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsfeed"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('ul', {
    attrs: {
      "id": "newsfeed"
    }
  }, _vm._l((_vm.newsItems), function(item) {
    return _c('li', [_c('div', {
      staticClass: "item-news"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-date"
    }, [_vm._v("Posted: " + _vm._s(_vm._f("moment")(item.created)))]), _vm._v(" "), _c('div', {
      staticClass: "item-description",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news btn btn-secondary btn-sm btn-readmore",
      attrs: {
        "to": item.path
      }
    }, [_vm._v("Read more >>\n                  ")])], 1)])])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42458f30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Newsfeed.vue
// module id = 367
// module chunks = 0